import { RectangleLocation, getExtremes } from './rectangle-location';
import { AxisDirection, isHorizontal } from './axis-direction';
export class DirectedRectangleError extends Error {
}
export function rotateDirection(direction, counterClockwise = false) {
    switch (direction) {
        case AxisDirection.Y_POSITIVE:
            return counterClockwise ? AxisDirection.X_NEGATIVE : AxisDirection.X_POSITIVE;
        case AxisDirection.X_NEGATIVE:
            return counterClockwise ? AxisDirection.Y_NEGATIVE : AxisDirection.Y_POSITIVE;
        case AxisDirection.Y_NEGATIVE:
            return counterClockwise ? AxisDirection.X_POSITIVE : AxisDirection.X_NEGATIVE;
        case AxisDirection.X_POSITIVE:
            return counterClockwise ? AxisDirection.Y_POSITIVE : AxisDirection.Y_NEGATIVE;
    }
}
function roundTohalf(value) {
    return Math.round(value * 2) / 2;
}
function rotatePointCCW(r, x, y) {
    return [roundTohalf(x * Math.cos(r) - y * Math.sin(r)), roundTohalf(x * Math.sin(r) + y * Math.cos(r))];
}
function rotatePointCW(r, x, y) {
    return [roundTohalf(y * Math.sin(r) + x * Math.cos(r)), roundTohalf(-y * Math.cos(r) + x * Math.sin(r))];
}
function vectorSub(vx, vy, vsx, vsy) {
    return [vx - vsx, vy - vsy];
}
function vectorAdd(vx, vy, vax, vay) {
    return [vx + vax, vy + vay];
}
function rotateDirectedRectangleLocation90Degrees(drl, counterClockwise = false, rotationCenterX, rotationCenterY) {
    const [xMin, yMin, xMax, yMax] = [drl.getXMin(), drl.getYMin(), drl.getXMax(), drl.getYMax()];
    // We want to rotate around box center, so we need to translate coordinates to box center
    // Translate to center relative coordinates
    const [xMinTR, yMinTR, xMaxTR, yMaxTR] = [...vectorSub(xMin, yMin, rotationCenterX, rotationCenterY), ...vectorSub(xMax, yMax, rotationCenterX, rotationCenterY)];
    // Rotate counterclockwise or counter clockwise
    if (counterClockwise) {
        const [xMaxR, yMinR, xMinR, yMaxR] = [...rotatePointCCW(Math.PI * 1 / 2, xMinTR, yMinTR), ...rotatePointCCW(Math.PI * 1 / 2, xMaxTR, yMaxTR)];
        // Calculate world coordinates after rotation
        drl.setLocation(...vectorAdd(rotationCenterX, rotationCenterY, xMinR, yMinR));
    }
    // Rotate clockwise
    else {
        const [xMinR, yMaxR, xMaxR, yMinR] = [...rotatePointCCW(Math.PI * 3 / 2, xMinTR, yMinTR), ...rotatePointCCW(Math.PI * 3 / 2, xMaxTR, yMaxTR)];
        // Calculate world coordinates after rotation
        drl.setLocation(...vectorAdd(rotationCenterX, rotationCenterY, xMinR, yMinR));
    }
    drl.setDirection(rotateDirection(drl.getDirection(), counterClockwise));
}
export function rotateDirectedRectangleLocations90Degrees(drls, counterClockwise = false) {
    const [xMin, yMin, xMax, yMax] = getExtremes(drls);
    const [rotationCenterX, rotationCenterY] = [xMin + (xMax - xMin) / 2, yMin + (yMax - yMin) / 2];
    drls.map(drl => rotateDirectedRectangleLocation90Degrees(drl, counterClockwise, rotationCenterX, rotationCenterY));
    return drls;
}
export class DirectedRectangleLocation extends RectangleLocation {
    constructor(width, length, x, y, direction) {
        super(width, length, x, y, isHorizontal(direction));
        this.direction = direction;
    }
    toCartesian() {
        const [x1, y1] = [this.getXMin(), this.getYMin()];
        return [[x1, y1], [x1 + this.getWidth(), y1 + this.getLength()]];
    }
    getDirection() {
        return this.direction;
    }
    setDirection(direction) {
        super.setRotated(isHorizontal(direction));
        this.direction = direction;
    }
    rotate(counterClockwise = false) {
        const [xMin, yMin, xMax, yMax] = [this.getXMin(), this.getYMin(), this.getXMax(), this.getYMax()];
        const [bcx, bcy] = [xMin + (xMax - xMin) / 2, yMin + (yMax - yMin) / 2];
        rotateDirectedRectangleLocation90Degrees(this, counterClockwise, bcx, bcy);
    }
    clone() {
        const drl = new DirectedRectangleLocation(this.getRectangleWidth(), this.getRectangleLength(), this.location.getX(), this.location.getY(), this.direction);
        return drl;
    }
    equalsDirectedRectangleLocation(drl2) {
        return super.equalsRectangleLocation(drl2)
            && this.getDirection() === drl2.getDirection();
    }
}
